/**
 * Human labels for the enum values the API sends as bare strings.
 *
 * `neubau`, `ordentlich`, `founder` are storage values, not copy. Where one is
 * rendered it goes through here; an unknown value falls back to itself rather
 * than to a wrong label, so a new backend value shows up raw instead of
 * disappearing — visible, and a reason to add a key.
 */
import { de, type TranslationKey } from './de'
import type { Translate } from './index'

function labelled(prefix: string, value: string | null | undefined, t: Translate): string | null {
  if (value === null || value === undefined || value === '') return null
  const key = `${prefix}${value}` as TranslationKey
  return key in de ? t(key) : value
}

/** `neubau` → «Neubau». The words on the eBaugesuch form. */
export function bautypLabel(value: string | null | undefined, t: Translate): string | null {
  return labelled('upload.bautyp.', value, t)
}

/** `ordentlich` → «Ordentliches Verfahren». */
export function verfahrenLabel(value: string | null | undefined, t: Translate): string | null {
  return labelled('upload.verfahren.', value, t)
}

/** `founder` / `admin` / `member` → the role as the reader knows it. */
export function roleLabel(value: string | null | undefined, t: Translate): string | null {
  return labelled('workspace.role.', value, t)
}
